import React from 'react';
import { ReactComponent as OutPatient } from 'assets/images/icons/sidebar/i-outpatient.svg'
import { ReactComponent as InPatient } from 'assets/images/icons/sidebar/i-inpatient.svg'
import { ReactComponent as HealthServices } from 'assets/images/icons/sidebar/i-health-services.svg'
import { ReactComponent as Dental } from 'assets/images/icons/sidebar/i-dental.svg'
import { ReactComponent as Nutrition } from 'assets/images/icons/sidebar/i-nutrition.svg'
import { ReactComponent as Laboratory } from 'assets/images/icons/sidebar/i-laboratory.svg'
import { ReactComponent as Cardiology } from 'assets/images/icons/sidebar/i-cardiology.svg'
import { ReactComponent as FamilyPractice } from 'assets/images/icons/sidebar/i-family-practice.svg'
import { ReactComponent as MentalHealth } from 'assets/images/icons/sidebar/i-mental-health.svg'
import { ReactComponent as Genetics } from 'assets/images/icons/sidebar/i-genetics.svg'
import { ReactComponent as Pharmacy } from 'assets/images/icons/sidebar/i-pharmacy.svg'
import { ReactComponent as CareStaffArea } from 'assets/images/icons/sidebar/i-care-staff-area.svg'
import { ReactComponent as Oncology } from 'assets/images/icons/sidebar/i-oncology.svg'
import { ReactComponent as Pathology } from 'assets/images/icons/sidebar/i-pathology.svg'
import { ReactComponent as Pediatrics } from 'assets/images/icons/sidebar/i-pediatrics.svg'
import { ReactComponent as IntensiveCare } from 'assets/images/icons/sidebar/i-intensive-care.svg'
import { ReactComponent as Immunizations } from 'assets/images/icons/sidebar/i-immunizations.svg'
import { ReactComponent as Ophthalmology } from 'assets/images/icons/sidebar/i-ophthalmology.svg'
import { ReactComponent as Registration } from 'assets/images/icons/sidebar/i-registration.svg'
import { ReactComponent as Billing } from 'assets/images/icons/sidebar/i-billing.svg'
//import { DollarSign,ShoppingCart } from 'react-feather'
import FeatherIcon from 'feather-icons-react'
const iconTypes = {
  OutPatient: OutPatient,
  InPatient: InPatient,
  HealthServices:HealthServices,
  Dental:Dental,
  Nutrition:Nutrition,
  Laboratory:Laboratory,
  Cardiology:Cardiology,
  FamilyPractice:FamilyPractice,
  MentalHealth:MentalHealth,
  Genetics:Genetics,
  Pharmacy:Pharmacy,
  CareStaffArea:CareStaffArea,
  Oncology:Oncology,
  Pathology:Pathology,
  Pediatrics:Pediatrics,
  IntensiveCare:IntensiveCare,
  Immunizations:Immunizations,
  Ophthalmology:Ophthalmology,
  Registration:Registration,
  DollarSign:<FeatherIcon
  size="16"
  icon="dollar-sign"
  className="vx-icon"            
/>,
  Billing:Billing,
  ShoppingCart:<FeatherIcon
  size="16"
  icon="shopping-cart"
  className="vx-icon"            
/>
};

const style = {
  img: {
    marginRight: 10,
    width: 20,
    height: 25,
    '&active': {
      fill: 'white',
    },
  },
  width: 20,
  height: 25,
}

const IconComponent = ({ name, ...props }) => {
  let Icon = iconTypes[name];
  return Icon ? (<Icon style={style} {...props} />):null;
};

export default IconComponent;
